export const STANDARD_RULES = [{required: true, message: 'Заполните поле'}]
